import { Component, OnInit, ElementRef } from "@angular/core";
import { NotificationHandlerService } from "src/app/services/notification-handler/notification-handler.service";
import { Navigator } from "../menu/navigator";
import { ScrollService } from "src/app/services/scroll/scroll.service";
import { Platform } from "@ionic/angular";
import { PopoverController } from "@ionic/angular";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
})

export class NotificationComponent implements OnInit {
  private event;
  private clickSubcriber;
  private globalClickListener: any;
  private isMobileDevices = false;
  private isAndroidDevice = false;

  constructor(
    private notificationHandler: NotificationHandlerService,
    private elRef: ElementRef,
    private readonly navigator: Navigator,
    private scroll: ScrollService,
    private platform: Platform,
    private popoverController:PopoverController,
  ) {}

  ngOnInit() {
    this.isMobileDevices =
      this.platform.is("capacitor") ||
      this.platform.is("android") ||
      this.platform.is("ios");
      this.isAndroidDevice = this.platform.is("android")
    this.event = this.notificationHandler.recentEvent;
    this.globalClickListener = (event) => this.onGlobalClick(event);
    document.addEventListener("click", this.globalClickListener, true);
  }

  clickEventHandler() {
    if (this.clickSubcriber) this.unSubcriber();
    this.clickSubcriber = this.scroll.getClickEvent().subscribe((e) => {
      this.onGlobalClick(e);
    });
  }
  onClickInside(event) {
    event.stopPropagation();
  }

  onGlobalClick(event) {
    if(this.navigator.activePopovers.length>0){
      this.popoverController.dismiss();
      this.navigator.activePopovers.pop();
      return;
    }
    if (event.target && event.target instanceof Element) {
      const isClickInsideAppNotification =
        event.target.closest("app-notification") !== null;
      if (isClickInsideAppNotification) {
        this.hidePopup();
      }
    }
    const clickedInside = this.elRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.hidePopup();
      event.stopPropagation();
    } else {
      if (
        event.target.getAttribute("data-button-type") == "customAction" ||
        event.target.getAttribute("data-button-text") == "customActionText"
      ) {
        this.clickAction(event);
      }
    }
  }

  hidePopup() {
    this.notificationHandler.hideNotification();
  }

  clickAction(e) {
    if (!this.event.actionComponent) return;
    return this.navigator.navigateTo(this.event.actionComponent, {
      customModalClass: "custom-shop-model-class-transparent",
      backdropDismiss: true,
    });
  }

  unSubcriber() {
    try {
      this.clickSubcriber.unsubscribe();
    } catch (e) {
      console.log("error", e);
    }
  }
  ngOnDestroy() {
    document.removeEventListener("click", this.globalClickListener, true);
  }
}
